var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmlFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 8.5,
    width: 35,
    height: 36,
    fill: "#D9D9D9",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 14.5,
    x2: 40,
    y2: 14.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 14.5,
    x2: 47,
    y2: 14.5,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 14.5,
    x2: 50,
    y2: 14.5,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 17.5,
    x2: 30,
    y2: 17.5,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 11.5,
    x2: 21,
    y2: 11.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 11.5,
    x2: 25,
    y2: 11.5,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 14.5,
    x2: 25,
    y2: 14.5,
    stroke: "black"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 17.5,
    x2: 43,
    y2: 17.5,
    stroke: "black"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 20.5,
    x2: 25,
    y2: 20.5,
    stroke: "black"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 20.5,
    x2: 39,
    y2: 20.5,
    stroke: "black"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 20.5,
    x2: 45,
    y2: 20.5,
    stroke: "black"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 23.5,
    x2: 25,
    y2: 23.5,
    stroke: "black"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 23.5,
    x2: 32,
    y2: 23.5,
    stroke: "black"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 23.5,
    x2: 40,
    y2: 23.5,
    stroke: "black"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 23.5,
    x2: 45,
    y2: 23.5,
    stroke: "black"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 26.5,
    x2: 29,
    y2: 26.5,
    stroke: "black"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 26.5,
    x2: 45,
    y2: 26.5,
    stroke: "black"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 29.5,
    x2: 42,
    y2: 29.5,
    stroke: "black"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 32.5,
    x2: 30,
    y2: 32.5,
    stroke: "black"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 32.5,
    x2: 39,
    y2: 32.5,
    stroke: "black"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 32.5,
    x2: 43,
    y2: 32.5,
    stroke: "black"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 35.5,
    x2: 34,
    y2: 35.5,
    stroke: "black"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 35.5,
    x2: 45,
    y2: 35.5,
    stroke: "black"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 38.5,
    x2: 27,
    y2: 38.5,
    stroke: "black"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 38.5,
    x2: 39,
    y2: 38.5,
    stroke: "black"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 38.5,
    x2: 45,
    y2: 38.5,
    stroke: "black"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 41.5,
    x2: 27,
    y2: 41.5,
    stroke: "black"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 41.5,
    x2: 35,
    y2: 41.5,
    stroke: "black"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 41.5,
    x2: 45,
    y2: 41.5,
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlFile);
export default __webpack_public_path__ + "static/media/htmlFile.5e286b44c87cf2c7799f2911295a3d20.svg";
export { ForwardRef as ReactComponent };